import { render, staticRenderFns } from "./BillingOverviewCard.vue?vue&type=template&id=32d06ec8&scoped=true&"
import script from "./BillingOverviewCard.vue?vue&type=script&lang=js&"
export * from "./BillingOverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d06ec8",
  null
  
)

export default component.exports